const createTagValidator = (tag) => {
  if (!tag?.name) throw new Error('Name is required');
  // if (!tag?.tag) throw new Error('Tag is required');
  // if (!tag?.date) throw new Error('Date is required');
  if (!tag?.description) throw new Error('Description is required');
  if (!tag?.company_ids?.length) throw new Error('Select at least one company');
};

export default createTagValidator;
